import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-takeover',
  templateUrl: './takeover.component.html'
})
export class TakeoverComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {      
      console.error('No token found in URL');
      this.router.navigateByUrl('/login');
      return;
    }

    const params = new HttpParams().set('token', token);

    this.http.get('/auth/takeover-login/', {
      params,
      withCredentials: true
    }).subscribe({
      next: (data) => {
        console.log('Takeover login successful:', data);
        this.router.navigateByUrl('/');
      },
      error: (err) => {
        console.error('Takeover login failed:', err);
        this.router.navigateByUrl('/login');
      }
    });
  }
}
